import { render, staticRenderFns } from "./DisableCouponForm.vue?vue&type=template&id=f9ceeca8"
import script from "./DisableCouponForm.vue?vue&type=script&lang=ts"
export * from "./DisableCouponForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports